import React, { Component } from 'react';
import { CircleCheckBig, KeyRound } from 'lucide-react';
import { APP_CONST } from '../../../../constants';
import { Auth } from '../../../../services';
import { GeckoAlert, GeckoBtn, GeckoFields, Spinner, PasswordPolicy } from '../../../../components';
import Flash from '../../../../services/Flash';
import Logout from '../../../../services/Logout';

const STATE_LOADING = 'loading';
const STATE_SUCCESS = 'success';


export class ModulePassword extends Component {
    state = {
        password_state: null,
        renderPasswordPolicy: false,
    }

    /**
     * Validate the password reset by confirming the new password
     * We could also implement password requirements here as well
     *
     * @return bool - is valid or nahhhh
     */
    validateNewPassword(PreviousPassword = null, ProposedPassword = null, ConfirmProposedPassword = null) {
        if (!PreviousPassword || !ProposedPassword) {
            return false;
        }

        if (ProposedPassword !== ConfirmProposedPassword) {
            return false;
        }

        return true;
    }

    handleChange(name, evt) {
        this.setState({
            [name]: evt,
            renderPasswordPolicy: true,
        });
    }

    submitHandler() {
        const { PreviousPassword, ProposedPassword, ConfirmProposedPassword } = this.state;

        if (this.validateNewPassword(PreviousPassword, ProposedPassword, ConfirmProposedPassword)) {
            this.setState({
                password_state: STATE_LOADING,
            });

            Auth.changePassword(PreviousPassword, ProposedPassword)
                .then(() => Flash.set(APP_CONST.FLASH.SUCCESSFUL_PASSWORD_CHANGE, String(true)))
                .then(() => Logout())
                .catch((err) => {
                    this.setState({ password_state: null, error: err.Error });
                })
        } else {
            this.setState({
                error: 'Please provide your current password and confirm a new password',
            })
        }
    }

    fields() {
        return [{
            label: 'Current password',
            key: 'PreviousPassword',
            width: '100%',
            type: APP_CONST.FIELD_TYPE_PASSWORD,
            required: true,
        }, {
            label: 'New password',
            key: 'ProposedPassword',
            width: '100%',
            type: APP_CONST.FIELD_TYPE_PASSWORD,
            required: true,
        }, {
            label: 'Confirm new password',
            key: 'ConfirmProposedPassword',
            width: '100%',
            type: APP_CONST.FIELD_TYPE_PASSWORD,
            required: true,
        },];
    }

    renderLoading() {
        return (
            <div className="row text mt-3 mb-3">
                <div className="col d-flex flex-column align-items-center">
                    <Spinner size="small" />
                </div>
            </div>
        )
    }

    renderSuccess() {
        return (
            <div id="ModulePassword_success">
                <div className="row icon">
                    <div className="col d-flex flex-column align-items-center text-success" style={{ fontSize: '50px' }}>
                        <CircleCheckBig />
                    </div>
                </div>

                <div className="row text">
                    <div className="col d-flex flex-column align-items-center">
                        Password Successfully changed
                    </div>
                </div>
            </div>
        )
    }

    renderAlert(message = null) {
        if (message) {
            return (
                <GeckoAlert type={APP_CONST.ALERT_TYPE_DANGER}>
                    {message}
                </GeckoAlert>
            )
        }

        return null;
    }

    render() {

        if (this.state.password_state === STATE_LOADING) {
            return this.renderLoading();
        }

        if (this.state.password_state === STATE_SUCCESS) {
            return this.renderSuccess();
        }

        const loginBtn = {
            name: 'Update password',
            icon: KeyRound,
            type: APP_CONST.BTN_TYPE_PRIMARY,
            handler: this.submitHandler.bind(this),
        };

        return (
            <div>
                {this.renderAlert(this.state.error)}

                <GeckoFields
                    fields={this.fields()}
                    values={this.state}
                    handler={this.handleChange.bind(this)}
                    submitHandler={this.submitHandler.bind(this)} />

                {this.state.renderPasswordPolicy &&
                    <div className="PasswordPolicyContainer p-3 border border-slate-200 rounded-sm my-2">
                        <PasswordPolicy value={this.state.ProposedPassword} />
                    </div>
                }

                <GeckoBtn className="mt-4" {...loginBtn}></GeckoBtn>

                <div className="change-password-message text-xs text-muted-foreground mt-2">After changing your password you will be asked to log in again.</div>
            </div>
        )
    }

}

export default ModulePassword;
